// -------------------------------------------
// JavaScript Objectfit Emulator
// Author: Globalia
// Licensed under the WTFPL license
// -------------------------------------------
// Replace all object-fit:cover|contain images with a background cover

( function( global ) { // eslint-disable-line

    var pluginName = 'grObjectfitEmulator';

    // Constructor

    function grObjectfitEmulator(selector) {
        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        this.init();
    };

    // Methods

    grObjectfitEmulator.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {

            // Bind all event handlers for referencability
            var arr = ['loadHandler'];
            for (var i = 0, len = arr.length; i < len; i++) {
                var method = arr[i];
                this[method] = this[method].bind(this);
            }
            if (this.selector.nodeType === 1 && this.selector.tagName.toLowerCase() === 'img')
                this.selector.addEventListener('load', this.loadHandler());
            else
                this.selector.addEventListener('loadedmetadata', this.loadHandler());

            // Flag the plugin as ready
            this.ready = true;
            this.selector.parentNode.setAttribute('gr-objectfit', 'ready');
            if (global.verbose) console.log(pluginName + '(' + this.selector.src + '): ready');
        }
    };

    grObjectfitEmulator.prototype.loadHandler = function loadHandler() {

        // Flag the plugin as processing
        this.state = 'processing';
        global.methods.toggleAttributeValue(this.selector.parentNode, 'gr-objectfit', 'processing');
        if (global.verbose) console.log(pluginName + '(' + this.selector.src + '): processing');

        if (this.selector.complete) {

            if(this.selector.nodeName.toLowerCase() === 'img')
                this.selector.removeEventListener('load', this.loadHandler);
            else
                this.selector.removeEventListener('loadedmetadata', this.loadHandler);

            this.selector.parentNode.classList.add('objectfit');

            this.selector.parentNode.style.backgroundImage = 'url('+ this.selector.src +')';

            // Flag the plugin as done
            this.state = 'done';
            global.methods.removeAttributeValue(this.selector.parentNode, 'gr-objectfit', 'processing');
            global.methods.toggleAttributeValue(this.selector.parentNode, 'gr-objectfit', 'done');
            if (global.verbose) console.log('grObjectfitEmulator(' + this.selector.src + '): done');
        }
    };

    // Destroy - remove listeners to prevent from memory leak
    // grPlugin.prototype.destroy = function destroy() {
    //     this.ready = 'false';
    //     removeAttributeValue(this.selector, 'gr-svg-inliner', 'ready processing done');
    //     if (groots.verbose) console.log(pluginName + ': destroyed');
    // };

    // jQuery wrapper, if available
    if(window.jQuery) {
        $.fn[pluginName] = function () {
            return this.each(function() {
                // add plugin to element data
                if (!$.data(this, pluginName) ) $.data(this, pluginName, new grObjectfitEmulator(this));
            });
        };
    }

    // Auto-Instantiation
    var all = {}, index;
    if (/MSIE|Trident|Edge/.test(navigator.userAgent) && document.querySelectorAll('img, video').length) {
        window.groots.grObjectfitEmulator = { instances: {} };
        all = document.querySelectorAll('img, video');
        index = -1;
        while (all[++index]) {
            var node = all[index];
            if(node.currentStyle)
                var objectFit = node.currentStyle['object-fit'];
            else if(window.getComputedStyle)
                var objectFit = document.defaultView.getComputedStyle(node, null).getPropertyValue('font-family');

            if (objectFit && /^(contain|cover|"cover")$/.test(objectFit))
                global.grObjectfitEmulator.instances[index] = new grObjectfitEmulator(all[index]);
        }
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grObjectfitEmulator;
    // Export to Browser
    else global[pluginName] = grObjectfitEmulator; // eslint-disable-line

}( window.groots ));
